import React, { useRef, useEffect } from 'react';
import ChangePreviewCard from './ChangePreviewCard';
import SimulationResultCard from './SimulationResultCard';

function AgentChatThread({
  messages,
  isStreaming,
  streamingText,
  onAcceptChange,
  onRejectChange,
  acceptedChanges,
}) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, streamingText]);

  return (
    <div className="graph-agent-messages">
      {messages.map((msg, idx) => {
        if (msg.role === 'user') {
          return (
            <div key={idx} className="graph-agent-msg graph-agent-msg--user">
              {msg.content}
            </div>
          );
        }

        if (msg.role === 'system') {
          return (
            <div key={idx} className="graph-agent-msg graph-agent-msg--system">
              {msg.content}
            </div>
          );
        }

        if (msg.role === 'assistant') {
          return (
            <div key={idx} className="graph-agent-msg graph-agent-msg--assistant">
              {msg.toolCalls && msg.toolCalls.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  {msg.toolCalls.map((tc, ti) => (
                    <span key={ti} className="graph-agent-msg__tool-badge">
                      {tc.toolName.replace(/_/g, ' ')}
                    </span>
                  ))}
                </div>
              )}

              {msg.content && (
                <div dangerouslySetInnerHTML={{ __html: simpleMarkdown(msg.content) }} />
              )}

              {msg.proposals && msg.proposals.map((proposal, pi) => (
                <ChangePreviewCard
                  key={pi}
                  proposal={proposal}
                  onAccept={() => onAcceptChange && onAcceptChange(idx, pi)}
                  onReject={() => onRejectChange && onRejectChange(idx, pi)}
                  accepted={acceptedChanges?.has(`${idx}-${pi}`)}
                />
              ))}

              {msg.simulations && msg.simulations.map((sim, si) => (
                <SimulationResultCard key={si} result={sim} label={sim._label} />
              ))}
            </div>
          );
        }

        return null;
      })}

      {isStreaming && streamingText && (
        <div className="graph-agent-msg graph-agent-msg--assistant">
          <div dangerouslySetInnerHTML={{ __html: simpleMarkdown(streamingText) }} />
        </div>
      )}

      {isStreaming && !streamingText && (
        <div className="graph-agent-typing">
          <div className="graph-agent-typing__dots">
            <span /><span /><span />
          </div>
          <span>Agent is thinking...</span>
        </div>
      )}

      <div ref={endRef} />
    </div>
  );
}

function simpleMarkdown(text) {
  if (!text) return '';
  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  html = html.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  html = html.replace(/\n/g, '<br/>');
  return html;
}

export default AgentChatThread;
